import { Helmet } from "react-helmet";
import { useEffect, useState } from "react";
import { PflegeCategory } from "../../shared/types";
import useFetch from "../Shared/useFetch";

function PiercingPflege() {
  const [categories, setCategories] = useState<PflegeCategory[]>([]);

  const FETCH = useFetch("/");

  useEffect(() => {
    const fetchCategories = async () => {
      const response = await FETCH.getPflegeCategories();
      setCategories(response);
    };

    fetchCategories().catch((error) => {
      console.error(error);
    });
  }, []);

  return (
    <div className="container mx-auto my-2 px-4">
      <Helmet>
        <title>Romy Tattoo & Piercing | Pflege</title>
        <meta
          name="description"
          content="Pflegeanleitungen für dein Piercing zum Herunterladen."
        />
      </Helmet>
      <h1 className="font-Forum pb-2 text-5xl xl:text-6xl md:text-left text-gray-700 2xl:text-7xl mt-4">
        Pflege
      </h1>
      <p className="pb-4 text-lg text-gray-500 2xl:text-xl">
        Die richtige Pflege ist entscheidend für einen komplikationsfreien
        Heilungsverlauf deines Piercings. Nimm dir kurz Zeit und lade dir die
        passende Pflegeanleitung für dein Piercing herunter &ndash; bei Fragen
        kannst du dich jederzeit bei mir melden.
      </p>
      <ul className="pb-8">
        {categories.map((category) => (
          <li key={category.id}>
            <a
              href={category.pdfPath}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-3 py-3 text-lg text-gray-700 border-b border-gray-200 hover:text-petrol-400 hover:font-bold 2xl:text-xl"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6 shrink-0"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                />
              </svg>
              Pflegeanleitung {category.name} (PDF)
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default PiercingPflege;
